/* Bannerlly theme JS — Theme Editor safe (re-inits on shopify:section:load) */
(function () {
  'use strict';

  /* ---------- scroll progress + header state (bind once) ---------- */
  var scrollBound = false;
  function bindScroll() {
    if (scrollBound) return;
    scrollBound = true;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var fill = document.getElementById('ruler-fill');
        if (fill) {
          var h = document.documentElement;
          fill.style.width = ((h.scrollTop / (h.scrollHeight - h.clientHeight)) * 100) + '%';
        }
        var header = document.getElementById('siteHeader');
        if (header) header.classList.toggle('scrolled', window.scrollY > 40);
        ticking = false;
      });
    });
  }

  /* ---------- reveal on scroll ---------- */
  var revealObserver = null;
  function observeReveals(root) {
    if (!('IntersectionObserver' in window)) {
      (root || document).querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in-view'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
    }
    (root || document).querySelectorAll('.reveal:not(.in-view)').forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* ---------- cycling hero word ---------- */
  function initCycleWords(root) {
    (root || document).querySelectorAll('.cycle-word[data-cycle-words]').forEach(function (el) {
      if (el.dataset.cycleInit) return;
      el.dataset.cycleInit = '1';
      var words = el.dataset.cycleWords.split('|').filter(Boolean);
      if (words.length < 2) return;
      var i = 0;
      setInterval(function () {
        if (!document.body.contains(el)) return;
        el.classList.add('swap');
        setTimeout(function () {
          i = (i + 1) % words.length;
          el.textContent = words[i];
          el.classList.remove('swap');
        }, 250);
      }, 2200);
    });
  }

  /* ---------- hero full-slide slider ---------- */
  function initHeroSlider(root) {
    (root || document).querySelectorAll('.hero3-slider').forEach(function (slider) {
      if (slider.dataset.sliderInit) return;
      slider.dataset.sliderInit = '1';

      var track = slider.querySelector('.hero3-slider-track');
      var slides = slider.querySelectorAll('.hero3-slide');
      var dots = slider.querySelectorAll('.hero3-dot');
      var prevBtn = slider.querySelector('.hero3-arrow--prev');
      var nextBtn = slider.querySelector('.hero3-arrow--next');
      var count = slides.length;
      if (!track || count < 2) return;

      var index = 0;
      var timer = null;
      var interval = parseInt(slider.dataset.interval, 10) || 6000;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function render() {
        track.style.transform = 'translateX(-' + (index * (100 / count)) + '%)';
        dots.forEach(function (d, i) { d.classList.toggle('active', i === index); });
      }

      function goTo(i) {
        index = ((i % count) + count) % count;
        render();
      }

      function next() { goTo(index + 1); }
      function prev() { goTo(index - 1); }

      function startAutoplay() {
        if (timer) clearInterval(timer);
        timer = setInterval(next, interval);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.slideIndex, 10) || 0);
          startAutoplay();
        });
      });

      render();
      if (!reducedMotion) startAutoplay();
    });
  }

  /* ---------- delegated: FAQ accordion ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.faq-q');
    if (!btn) return;
    var item = btn.closest('.faq-item');
    var wasOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(function (o) {
      o.classList.remove('open');
      var b = o.querySelector('.faq-q');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) {
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });

  /* ---------- delegated: mobile drawer ---------- */
  function setDrawer(open) {
    var drawer = document.getElementById('mobileDrawer');
    var overlay = document.getElementById('mobileDrawerOverlay');
    if (drawer) { drawer.classList.toggle('open', open); drawer.setAttribute('aria-hidden', open ? 'false' : 'true'); }
    if (overlay) overlay.classList.toggle('open', open);
    var toggle = document.querySelector('.nav-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    // collapse all groups when closing
    if (!open) {
      document.querySelectorAll('.drawer-group.open').forEach(function (g) {
        g.classList.remove('open');
        var btn = g.querySelector('.drawer-toggle');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.nav-toggle')) { setDrawer(true); return; }
    if (e.target.closest('.mobile-drawer-close') || e.target.closest('.mobile-drawer-overlay')) { setDrawer(false); return; }
    // expand/collapse category group — stop, don't close drawer
    var toggleBtn = e.target.closest('.drawer-toggle');
    if (toggleBtn) {
      var group = toggleBtn.closest('.drawer-group');
      if (group) {
        var isOpen = group.classList.contains('open');
        group.classList.toggle('open', !isOpen);
        toggleBtn.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      }
      return;
    }
    // close drawer only when navigating (child link or plain link)
    if (e.target.closest('.drawer-child-link') || e.target.closest('.drawer-plain-link')) { setDrawer(false); return; }
    // tapping category name navigates but also closes drawer
    if (e.target.closest('.drawer-cat-link')) { setDrawer(false); return; }
  });

  /* ---------- delegated: footer accordion (mobile only — CSS forces open on desktop) ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.fgroup-head');
    if (!head) return;
    var group = head.closest('.fgroup');
    if (!group) return;
    var isOpen = group.classList.contains('open');
    group.classList.toggle('open', !isOpen);
    head.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
  });

  /* ---------- delegated: header search toggle ---------- */
  document.addEventListener('click', function (e) {
    var wrap = document.querySelector('.nav-search');
    if (!wrap) return;
    var toggle = e.target.closest('.nav-search-toggle');
    if (toggle) {
      var isOpen = wrap.classList.contains('open');
      wrap.classList.toggle('open', !isOpen);
      toggle.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      if (!isOpen) {
        var input = wrap.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      }
      return;
    }
    if (wrap.classList.contains('open') && !e.target.closest('.nav-search-panel')) {
      wrap.classList.remove('open');
      var btn = wrap.querySelector('.nav-search-toggle');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---------- delegated: quote form body bundling ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#quoteForm');
    if (!form) return;
    var get = function (id) { var el = form.querySelector('#' + id); return el ? el.value : ''; };
    var body = form.querySelector('#contactBody');
    if (body) {
      body.value = 'Product: ' + get('quoteProduct') + '\n' +
                   'Size needed: ' + get('quoteSize') + '\n' +
                   'Notes: ' + get('quoteNotes');
    }
  });

  /* ---------- collection filters/sort auto-submit ---------- */
  document.addEventListener('change', function (e) {
    var form = e.target.closest('#CollectionFilters');
    if (form) form.submit();
  });

  /* ---------- product gallery thumbs (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-thumb');
    if (!btn) return;
    var main = document.getElementById('mainProductImage');
    document.querySelectorAll('.product-thumb').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    if (main) main.src = btn.dataset.full;
  });

  /* ---------- delegated: product page tabs ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.pdp-tab');
    if (!tab) return;
    var wrap = tab.closest('.pdp-tabs-wrap');
    if (!wrap) return;
    wrap.querySelectorAll('.pdp-tab').forEach(function (t) {
      var active = t === tab;
      t.classList.toggle('active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    wrap.querySelectorAll('.pdp-panel').forEach(function (p) {
      p.hidden = p.dataset.panel !== tab.dataset.tab;
    });
  });

  /* ---------- sq ft calculator (native form submit) ---------- */
  function initCalculator(root) {
    var calc = (root || document).querySelector('#calculatorRoot');
    if (!calc || calc.dataset.calcInit) return;
    calc.dataset.calcInit = '1';

    var minSqft = parseFloat(calc.dataset.minSqft) || 0;
    var minCharge = parseFloat(calc.dataset.minCharge) || 0;
    var productTitle = calc.dataset.productTitle || 'Print job';
    var variantAvailable = true;
    var widthFtEl = calc.querySelector('#calcWidthFt');
    var widthInEl = calc.querySelector('#calcWidthIn');
    var heightFtEl = calc.querySelector('#calcHeightFt');
    var heightInEl = calc.querySelector('#calcHeightIn');
    var qtyEl = calc.querySelector('#calcQty');
    var variantEl = calc.querySelector('#calcVariant');
    var turnaroundRadios = Array.prototype.slice.call(calc.querySelectorAll('input[name="properties[Turnaround]"]'));
    if (variantEl && variantEl.tagName !== 'SELECT') {
      variantAvailable = variantEl.dataset.available !== 'false';
    }
    var out = {
      dimLabel: calc.querySelector('#calcDimLabel'),
      perUnit: calc.querySelector('#calcSqftPerUnit'),
      rateLabel: calc.querySelector('#calcRateLabel'),
      minCharge: calc.querySelector('#calcMinCharge'),
      total: calc.querySelector('#calcTotalSqft'),
      basePrice: calc.querySelector('#calcBasePrice'),
      turnaroundRow: calc.querySelector('#calcTurnaroundRow'),
      turnaroundFee: calc.querySelector('#calcTurnaroundFee'),
      price: calc.querySelector('#calcTotalPrice'),
      minNotice: calc.querySelector('#calcMinNotice'),
      minValue: calc.querySelector('#calcMinNoticeValue'),
      unitPrice: document.getElementById('unitPriceDisplay')
    };
    var hidden = {
      quantity: calc.querySelector('#calcQuantityField'),
      width: calc.querySelector('#propWidth'),
      height: calc.querySelector('#propHeight'),
      pieces: calc.querySelector('#propPieces'),
      sqftUnit: calc.querySelector('#propSqftUnit'),
      sqftBilled: calc.querySelector('#propSqftBilled'),
      orderTotal: calc.querySelector('#propOrderTotal')
    };
    function money(n) { return '$' + n.toFixed(2); }
    if (out.minValue) out.minValue.textContent = money(minCharge);
    if (out.minCharge) out.minCharge.textContent = money(minCharge);

    // running total already in the customer's cart — used only to decide whether
    // the turnaround rush fee should be waived (order totals $200+). Fetched once
    // on load and refreshed after this product is added.
    var cartSubtotalCents = 0;
    function refreshCartSubtotal() {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { cartSubtotalCents = c.total_price || 0; update(); })
        .catch(function () { /* non-fatal — fee check just assumes an empty cart */ });
    }

    function pricePerSqft() {
      if (!variantEl) return 0;
      if (variantEl.tagName === 'SELECT') {
        var opt = variantEl.options[variantEl.selectedIndex];
        return opt ? parseFloat(opt.dataset.price) || 0 : 0;
      }
      return parseFloat(variantEl.dataset.price) || 0;
    }

    function selectedRadioData(radios, attr) {
      var checked = radios.filter(function (r) { return r.checked; })[0];
      return checked ? parseFloat(checked.dataset[attr]) || 0 : 0;
    }
    function selectedRadioLabel(radios) {
      var checked = radios.filter(function (r) { return r.checked; })[0];
      return checked ? checked.value : '';
    }

    // Width/height are entered as feet + inches parts of ONE measurement
    // (e.g. 12 ft + 2 in = 146 in total) — both fields add together rather
    // than mirroring each other, so a customer can fill in either one alone
    // or both together. If inches overflows 12, the extra whole foot carries
    // over into the feet field automatically once they leave the field.
    function round(n, places) {
      var f = Math.pow(10, places);
      return Math.round(n * f) / f;
    }
    function clampNonNeg(n) {
      return (isNaN(n) || n < 0) ? 0 : n;
    }
    function normalizePair(ftEl, inEl) {
      var ft = clampNonNeg(parseFloat(ftEl && ftEl.value));
      var inch = clampNonNeg(parseFloat(inEl && inEl.value));
      if (inch >= 12) {
        var carry = Math.floor(inch / 12);
        ft += carry;
        inch -= carry * 12;
      }
      ft = Math.floor(ft);
      inch = round(inch, 1);
      if (ftEl) ftEl.value = ft || '';
      if (inEl) inEl.value = inch || '';
    }
    // total inches — both fields simply add together
    function dimInches(ftEl, inEl) {
      var ft = clampNonNeg(parseFloat(ftEl && ftEl.value));
      var inch = clampNonNeg(parseFloat(inEl && inEl.value));
      return (ft * 12) + inch;
    }
    function fmtDim(totalIn) {
      var ft = Math.floor(totalIn / 12);
      var inch = Math.round(totalIn - ft * 12);
      if (inch === 12) { ft += 1; inch = 0; }
      return ft + "' " + inch + '"';
    }

    // module-level so the submit handler can read the final numbers without recomputing
    var lastCalc = { basePrice: 0, turnaroundFee: 0, grandTotal: 0, pieces: 1, rate: 0 };

    function update() {
      var wIn = dimInches(widthFtEl, widthInEl);
      var hIn = dimInches(heightFtEl, heightInEl);
      var wFt = wIn / 12;
      var hFt = hIn / 12;
      var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);

      var hasSize = wIn > 0 && hIn > 0;
      var perUnitSqft = wFt * hFt;
      var rate = pricePerSqft();

      var billableSqft = 0;
      var basePrice = 0;
      var underMin = false;

      // priced options (Sides/Grommets/Hem, etc.) — per_sqft choices scale with
      // area, flat choices are a per-piece fee added once qty is known
      var pricedSelects = Array.prototype.slice.call(calc.querySelectorAll('select[data-priced-option]'));
      var extraPerSqft = 0, extraFlatPerPiece = 0;
      pricedSelects.forEach(function (sel) {
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        var amt = parseFloat(opt.dataset.priceAmount) || 0;
        if (opt.dataset.priceType === 'per_sqft') extraPerSqft += amt;
        else extraFlatPerPiece += amt;
      });

      if (hasSize) {
        billableSqft = Math.max(perUnitSqft * qty, minSqft);
        basePrice = Math.max(billableSqft * rate, minCharge * qty)
          + (billableSqft * extraPerSqft)
          + (extraFlatPerPiece * qty);
        underMin = (billableSqft * rate) < (minCharge * qty);
      }

      // turnaround rush fee — waived once (existing cart + this item's base price)
      // reaches that option's free-over threshold
      var turnaroundExtra = selectedRadioData(turnaroundRadios, 'extraFee');
      var turnaroundFreeOver = selectedRadioData(turnaroundRadios, 'freeOver');
      var prospectiveOrderTotal = (cartSubtotalCents / 100) + basePrice;
      var turnaroundFee = 0;
      if (hasSize && turnaroundExtra > 0 && (turnaroundFreeOver <= 0 || prospectiveOrderTotal < turnaroundFreeOver)) {
        turnaroundFee = turnaroundExtra;
      }

      var grandTotal = basePrice + turnaroundFee;

      // cart quantity is set to BILLING UNITS (grand total ÷ rate, rounded up)
      // so Shopify's own price × quantity math always lands on this exact
      // total — same mechanism as any plain Shopify product, just computed.
      var billingUnits = 1;
      var actualCharge = 0;
      if (hasSize && rate > 0) {
        billingUnits = Math.max(1, Math.ceil((grandTotal / rate) - 0.001));
        actualCharge = billingUnits * rate;
      }

      if (out.dimLabel) out.dimLabel.textContent = fmtDim(wIn) + ' × ' + fmtDim(hIn);
      if (out.perUnit) out.perUnit.textContent = perUnitSqft.toFixed(1) + ' ft²';
      if (out.rateLabel) out.rateLabel.textContent = money(rate) + '/ft²';
      if (out.total) out.total.textContent = (hasSize ? billingUnits : 0).toFixed(1) + ' ft²';
      if (out.basePrice) out.basePrice.textContent = hasSize ? money(basePrice) : '$0.00';
      if (out.turnaroundRow) out.turnaroundRow.hidden = turnaroundFee <= 0;
      if (out.turnaroundFee) out.turnaroundFee.textContent = money(turnaroundFee);
      if (out.price) out.price.textContent = hasSize ? money(actualCharge) : '$0.00';
      if (out.minNotice) out.minNotice.hidden = !hasSize || !underMin;
      if (out.unitPrice && variantEl && variantEl.tagName === 'SELECT') {
        var opt = variantEl.options[variantEl.selectedIndex];
        if (opt && opt.dataset.priceFormatted) out.unitPrice.textContent = opt.dataset.priceFormatted;
      }
      if (addBtn) {
        addBtn.disabled = !hasSize || !variantAvailable;
      }

      if (hidden.quantity) hidden.quantity.value = hasSize ? billingUnits : 1;
      if (hidden.width) hidden.width.value = fmtDim(wIn);
      if (hidden.height) hidden.height.value = fmtDim(hIn);
      if (hidden.pieces) hidden.pieces.value = qty;
      if (hidden.sqftUnit) hidden.sqftUnit.value = perUnitSqft.toFixed(1);
      if (hidden.sqftBilled) hidden.sqftBilled.value = (hasSize ? billingUnits : 1).toFixed(1);
      if (hidden.orderTotal) hidden.orderTotal.value = money(actualCharge);

      lastCalc = { basePrice: basePrice, turnaroundFee: turnaroundFee, grandTotal: grandTotal, pieces: qty, rate: rate };
    }

    /* b2sign-style option rows -> variant resolution */
    var optSelects = Array.prototype.slice.call(calc.querySelectorAll('.opt-select'));
    var addBtn = calc.querySelector('#addToCartBtn');

    function syncVariantFromOptions() {
      if (!optSelects.length || !variantEl || variantEl.tagName !== 'SELECT') return;
      var chosen = optSelects
        .sort(function (a, b) { return (+a.dataset.optionIndex) - (+b.dataset.optionIndex); })
        .map(function (s) { return s.value; });
      var match = null;
      Array.prototype.forEach.call(variantEl.options, function (opt) {
        if (match) return;
        try {
          var opts = JSON.parse(opt.dataset.options || '[]');
          if (opts.length === chosen.length && opts.every(function (v, i) { return v === chosen[i]; })) match = opt;
        } catch (err) { /* ignore malformed */ }
      });
      if (match) variantEl.value = match.value;
      var current = variantEl.options[variantEl.selectedIndex];
      var available = !current || current.dataset.available !== 'false';
      variantAvailable = available && !!match;
      if (addBtn) {
        addBtn.textContent = (!match) ? 'Unavailable' : (available ? 'Add to Cart' : 'Sold out');
      }
    }

    optSelects.forEach(function (s) {
      s.addEventListener('change', function () { syncVariantFromOptions(); update(); });
    });

    if (widthFtEl) {
      widthFtEl.addEventListener('input', update);
      widthFtEl.addEventListener('change', function () { normalizePair(widthFtEl, widthInEl); update(); });
    }
    if (widthInEl) {
      widthInEl.addEventListener('input', update);
      widthInEl.addEventListener('change', function () { normalizePair(widthFtEl, widthInEl); update(); });
    }
    if (heightFtEl) {
      heightFtEl.addEventListener('input', update);
      heightFtEl.addEventListener('change', function () { normalizePair(heightFtEl, heightInEl); update(); });
    }
    if (heightInEl) {
      heightInEl.addEventListener('input', update);
      heightInEl.addEventListener('change', function () { normalizePair(heightFtEl, heightInEl); update(); });
    }
    [qtyEl, variantEl].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', update);
      el.addEventListener('change', update);
    });
    turnaroundRadios.forEach(function (r) { r.addEventListener('change', update); });
    Array.prototype.slice.call(calc.querySelectorAll('select[data-priced-option]')).forEach(function (sel) {
      sel.addEventListener('change', update);
    });

    /* ---------- job name / artwork required-field validation ---------- */
    var jobNameEl = calc.querySelector('#calcJobName');
    var jobNameError = calc.querySelector('#calcJobNameError');
    var artworkInput = calc.querySelector('#calcArtwork');
    var artworkError = calc.querySelector('#calcArtworkError');
    var resWarning = calc.querySelector('#calcResWarning');
    var resWarningDismiss = calc.querySelector('#calcResWarningDismiss');
    var lastImageNaturalSize = null; // {w, h} of the most recently uploaded raster image

    function validateJobName() {
      var ok = true;
      if (jobNameEl && jobNameEl.hasAttribute('required') && !jobNameEl.value.trim()) {
        jobNameEl.classList.add('field-invalid');
        if (jobNameError) jobNameError.hidden = false;
        ok = false;
      } else if (jobNameEl) {
        jobNameEl.classList.remove('field-invalid');
        if (jobNameError) jobNameError.hidden = true;
      }
      return ok;
    }
    function validateArtwork() {
      var ok = true;
      if (artworkInput && artworkInput.hasAttribute('required') && !artworkInput.files.length) {
        artworkInput.classList.add('field-invalid');
        if (artworkError) artworkError.hidden = false;
        ok = false;
      } else if (artworkInput) {
        artworkInput.classList.remove('field-invalid');
        if (artworkError) artworkError.hidden = true;
      }
      return ok;
    }
    // Combined check — only used right before a real add-to-cart attempt,
    // so both errors only ever appear together when the customer has
    // actually tried to submit with fields still missing. Interacting with
    // one field (typing a job name, choosing a file) must never flag the
    // OTHER, untouched field as an error.
    function validateRequiredFields() {
      var jobOk = validateJobName();
      var artworkOk = validateArtwork();
      return jobOk && artworkOk;
    }
    if (jobNameEl) jobNameEl.addEventListener('input', validateJobName);

    var RASTER_TYPES = { 'image/jpeg': 1, 'image/jpg': 1, 'image/png': 1 };

    function currentPrintInches() {
      var wIn = dimInches(widthFtEl, widthInEl);
      var hIn = dimInches(heightFtEl, heightInEl);
      return { w: wIn, h: hIn };
    }


    function checkResolution() {
      if (!lastImageNaturalSize || !resWarning) return;
      var size = currentPrintInches();
      if (!size.w || !size.h) { resWarning.hidden = true; return; }
      var minDpi = parseFloat(artworkInput && artworkInput.dataset.minDpi) || 100;
      var dpiW = lastImageNaturalSize.w / size.w;
      var dpiH = lastImageNaturalSize.h / size.h;
      var effectiveDpi = Math.min(dpiW, dpiH);
      resWarning.hidden = effectiveDpi >= minDpi;
    }

    // recheck resolution whenever the entered size changes (image may already be uploaded)
    [widthFtEl, widthInEl, heightFtEl, heightInEl].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', checkResolution);
    });

    if (resWarningDismiss) {
      resWarningDismiss.addEventListener('click', function () { resWarning.hidden = true; });
    }

    if (artworkInput) {
      artworkInput.addEventListener('change', function () {
        validateArtwork();
        lastImageNaturalSize = null;
        if (resWarning) resWarning.hidden = true;

        var file = artworkInput.files && artworkInput.files[0];
        if (!file) return;

        var isRaster = !!RASTER_TYPES[file.type];
        if (!isRaster) return; // can't read pixel dimensions for PDF/AI/EPS/TIFF — no resolution check possible

        // Load the image just to read its natural pixel size for the DPI/resolution
        // check below — no visual preview is rendered.
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          lastImageNaturalSize = { w: img.naturalWidth, h: img.naturalHeight };
          checkResolution();
          URL.revokeObjectURL(url);
        };
        img.onerror = function () { URL.revokeObjectURL(url); };
        img.src = url;
      });
    }

    // AJAX add to cart. If this product has a configured "shadow pricing
    // product" (data-shadow-product-id), we call the dynamic-pricing worker
    // to mint a variant priced at grandTotal/pieces, then submit that variant
    // with quantity = real pieces — native qty shows pieces everywhere.
    // If not configured, falls back to the old billing-units behavior so
    // nothing breaks on products you haven't set up yet.
    var shadowProductId = calc.dataset.shadowProductId || '';
    var workerUrl = calc.dataset.pricingWorkerUrl || '';
    var workerKey = calc.dataset.pricingWorkerKey || '';

    function getShadowVariant() {
      var unitCents = Math.round((lastCalc.grandTotal / Math.max(1, lastCalc.pieces)) * 100);
      return fetch(workerUrl.replace(/\/$/, '') + '/price-variant', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Bannerlly-Key': workerKey },
        body: JSON.stringify({
          shadowProductId: shadowProductId,
          pieces: lastCalc.pieces,
          unitPriceCents: unitCents,
          jobLabel: productTitle
        })
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw new Error(e.error || 'pricing failed'); });
        return res.json();
      }).then(function (data) { return data.variantId; });
    }

    calc.addEventListener('submit', function (e) {
      e.preventDefault();
      update();
      if (addBtn && addBtn.disabled) return;
      if (!validateRequiredFields()) {
        var firstInvalid = calc.querySelector('.field-invalid');
        if (firstInvalid) { firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' }); firstInvalid.focus(); }
        return;
      }

      var formData = new FormData(calc);
      if (addBtn) { addBtn.disabled = true; addBtn.dataset.prevLabel = addBtn.textContent; addBtn.textContent = 'Adding…'; }

      var specKeys = ['Job Name', 'Turnaround', 'Fulfillment', '_Width (ft)', '_Height (ft)'];
      var usingShadowPricing = !!(shadowProductId && workerUrl);
      var thisVariantId = variantEl ? (variantEl.tagName === 'SELECT' ? variantEl.value : variantEl.value) : null;

      function specMatches(item) {
        if (!item.properties) return false;
        // Shadow-priced lines get a brand new variant id every time, so match
        // on the real product's variant id (stored as a property) instead.
        if (usingShadowPricing) {
          if ((item.properties['_Source Variant'] || '') !== String(thisVariantId)) return false;
        } else if (String(item.id) !== String(thisVariantId)) {
          return false;
        }
        return specKeys.every(function (k) {
          var a = (item.properties[k] || '').toString().trim();
          var b = (formData.get('properties[' + k + ']') || '').toString().trim();
          return a === b;
        });
      }

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var existing = cart.items.filter(function (i) {
            return i.properties && i.properties['_Pieces'] && specMatches(i);
          })[0];

          if (existing) {
            var removals = {};
            removals[existing.key] = 0;
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ updates: removals })
            }).then(function (res) {
              if (!res.ok) { return res.json().then(function (err) { throw err; }); }
              return res.json();
            }).then(function () { return addLine(); });
          }

          return addLine();
        })
        .then(function () {
          if (window.BannerllyCart) { window.BannerllyCart.refresh(true); }
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.dataset.prevLabel || 'Add to Cart'; }
          refreshCartSubtotal();
        })
        .catch(function (err) {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.dataset.prevLabel || 'Add to Cart'; }
          var msg = (err && err.message) ? err.message : (err && err.description) ? err.description : 'Sorry — could not add this to the cart. Please try again.';
          alert(msg);
        });

      function addLine() {
        if (!usingShadowPricing) {
          // Fallback: old billing-units behavior (unchanged), used only for
          // products that haven't been set up with a shadow pricing product.
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          }).then(function (res) {
            if (!res.ok) { return res.json().then(function (err) { throw err; }); }
            return res.json();
          });
        }

        return getShadowVariant().then(function (variantId) {
          formData.set('id', variantId);
          formData.set('quantity', lastCalc.pieces);
          formData.set('properties[_Source Variant]', String(thisVariantId));
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          }).then(function (res) {
            if (!res.ok) { return res.json().then(function (err) { throw err; }); }
            return res.json();
          });
        });
      }
    });

    syncVariantFromOptions();
    refreshCartSubtotal();
    update();
  }

  /* ---------- cart drawer + AJAX cart module ---------- */
  var BannerllyCart = (function () {
    function drawer() { return document.getElementById('cartDrawer'); }
    function overlay() { return document.getElementById('cartDrawerOverlay'); }

    function open() {
      var d = drawer(), o = overlay();
      if (d) { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); }
      if (o) o.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      var d = drawer(), o = overlay();
      if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
      if (o) o.classList.remove('open');
      document.body.style.overflow = '';
    }

    function updateCount(count) {
      var badge = document.querySelector('.cart-count');
      var navCart = document.querySelector('.nav-cart');
      var drawerCount = document.getElementById('cartDrawerCount');
      if (drawerCount) drawerCount.textContent = '(' + count + ')';
      if (count > 0) {
        if (!badge && navCart) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          navCart.appendChild(badge);
        }
        if (badge) badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    }

    // Re-render drawer contents + count via the Section Rendering API
    function refresh(openAfter) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var realCount = cart.items.reduce(function (sum, item) {
            var pieces = item.properties && item.properties['_Pieces'];
            return sum + (pieces ? parseInt(pieces, 10) || 0 : item.quantity);
          }, 0);
          updateCount(realCount);
          return fetch('/cart?section_id=cart-drawer-render');
        })
        .then(function (res) { return res.ok ? res.text() : null; })
        .then(function (html) {
          var body = document.getElementById('cartDrawerBody');
          if (html && body) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var rendered = doc.querySelector('.shopify-section') || doc.body;
            if (rendered) body.innerHTML = rendered.innerHTML;
          }
          if (openAfter) open();
        })
        .catch(function () { if (openAfter) open(); });
    }

    // Plain quantity update — calculator items don't expose the raw +/-
    // stepper (they show "Edit size/qty" instead).
    function changeQty(key, qty) {
      var updates = {};
      updates[key] = qty;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (res) { return res.json(); })
        .then(function () { refresh(false); });
    }

    // delegated events for drawer controls
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); refresh(true); return; }
      if (e.target.closest('.cart-drawer-close') || e.target.closest('#cartDrawerOverlay') || e.target.closest('.cart-drawer-continue')) { close(); return; }

      var qbtn = e.target.closest('.qty-btn');
      if (qbtn) {
        var wrap = qbtn.closest('.cart-drawer-qty');
        var input = wrap.querySelector('.qty-input');
        var cur = parseInt(input.value, 10) || 0;
        var next = qbtn.dataset.action === 'increase' ? cur + 1 : Math.max(0, cur - 1);
        changeQty(wrap.dataset.lineKey, next);
        return;
      }
      var rm = e.target.closest('.cart-drawer-line-remove');
      if (rm) { changeQty(rm.dataset.lineKey, 0); return; }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('.cart-drawer-qty .qty-input');
      if (input) {
        var wrap = input.closest('.cart-drawer-qty');
        changeQty(wrap.dataset.lineKey, Math.max(0, parseInt(input.value, 10) || 0));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    return { open: open, close: close, refresh: refresh, changeQty: changeQty };
  })();
  window.BannerllyCart = BannerllyCart;

  /* ---------- cart page: live quantity updates (no reload / no Update button needed) ---------- */
  function initCartPage(root) {
    var page = (root || document).querySelector('#cartPageRoot');
    if (!page || page.dataset.cartPageInit) return;
    page.dataset.cartPageInit = '1';

    function refreshCartPage() {
      fetch('/cart?section_id=main')
        .then(function (res) { return res.ok ? res.text() : null; })
        .then(function (html) {
          if (!html) { window.location.reload(); return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var rendered = doc.querySelector('#cartPageRoot');
          var current = document.getElementById('cartPageRoot');
          if (rendered && current) {
            current.innerHTML = rendered.innerHTML;
          } else {
            window.location.reload();
          }
        })
        .catch(function () { window.location.reload(); });
    }

    document.addEventListener('click', function (e) {
      var root2 = e.target.closest('#cartPageRoot');
      if (!root2) return;
      var qbtn = e.target.closest('.qty-btn');
      if (qbtn) {
        e.preventDefault();
        var wrap = qbtn.closest('.qty-stepper');
        var input = wrap.querySelector('.qty-input');
        var cur = parseInt(input.value, 10) || 0;
        var next = qbtn.dataset.action === 'increase' ? cur + 1 : Math.max(0, cur - 1);
        if (window.BannerllyCart) window.BannerllyCart.changeQty(wrap.dataset.lineKey, next).then(refreshCartPage);
        return;
      }
      var rm = e.target.closest('.cart-line-remove');
      if (rm && rm.dataset.lineKey) {
        e.preventDefault();
        if (window.BannerllyCart) window.BannerllyCart.changeQty(rm.dataset.lineKey, 0).then(refreshCartPage);
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('#cartPageRoot .qty-stepper .qty-input');
      if (!input) return;
      var wrap = input.closest('.qty-stepper');
      var next = Math.max(0, parseInt(input.value, 10) || 0);
      if (window.BannerllyCart) window.BannerllyCart.changeQty(wrap.dataset.lineKey, next).then(refreshCartPage);
    });
  }

  /* ---------- simple product page (no calculator): variant + AJAX add ---------- */
  function initSimpleProduct(root) {
    var form = (root || document).querySelector('#simpleProductForm');
    if (!form || form.dataset.simpleInit) return;
    form.dataset.simpleInit = '1';

    var variantEl = form.querySelector('#simpleVariantId');
    var optSelects = Array.prototype.slice.call(form.querySelectorAll('.simple-opt-select'));
    var addBtn = form.querySelector('#simpleAddToCartBtn');
    var priceEl = document.getElementById('unitPriceDisplay');

    function syncVariant() {
      if (!optSelects.length || !variantEl || variantEl.tagName !== 'SELECT') return;
      var chosen = optSelects
        .sort(function (a, b) { return (+a.dataset.optionIndex) - (+b.dataset.optionIndex); })
        .map(function (s) { return s.value; });
      var match = null;
      Array.prototype.forEach.call(variantEl.options, function (opt) {
        if (match) return;
        try {
          var opts = JSON.parse(opt.dataset.options || '[]');
          if (opts.length === chosen.length && opts.every(function (v, i) { return v === chosen[i]; })) match = opt;
        } catch (err) { /* ignore malformed */ }
      });
      if (match) variantEl.value = match.value;
      var current = variantEl.options[variantEl.selectedIndex];
      var available = !current || current.dataset.available !== 'false';
      if (priceEl && current && current.dataset.priceFormatted) priceEl.textContent = current.dataset.priceFormatted;
      if (addBtn) {
        addBtn.disabled = !available || !match;
        addBtn.textContent = (!match) ? 'Unavailable' : (available ? 'Add to Cart' : 'Sold out');
      }
    }

    optSelects.forEach(function (s) { s.addEventListener('change', syncVariant); });
    syncVariant();

    var simpleJobName = form.querySelector('#simpleJobName');
    var simpleJobNameError = form.querySelector('#simpleJobNameError');
    var simpleArtworkInput = form.querySelector('input[type="file"][name="properties[Artwork]"]');
    var simpleArtworkError = form.querySelector('#simpleArtworkError');

    function validateSimpleJobName() {
      var ok = true;
      if (simpleJobName && simpleJobName.hasAttribute('required') && !simpleJobName.value.trim()) {
        simpleJobName.classList.add('field-invalid');
        if (simpleJobNameError) simpleJobNameError.hidden = false;
        ok = false;
      } else if (simpleJobName) {
        simpleJobName.classList.remove('field-invalid');
        if (simpleJobNameError) simpleJobNameError.hidden = true;
      }
      return ok;
    }
    function validateSimpleArtwork() {
      var ok = true;
      if (simpleArtworkInput && simpleArtworkInput.hasAttribute('required') && !simpleArtworkInput.files.length) {
        simpleArtworkInput.classList.add('field-invalid');
        if (simpleArtworkError) simpleArtworkError.hidden = false;
        ok = false;
      } else if (simpleArtworkInput) {
        simpleArtworkInput.classList.remove('field-invalid');
        if (simpleArtworkError) simpleArtworkError.hidden = true;
      }
      return ok;
    }
    function validateRequiredFields() {
      var jobOk = validateSimpleJobName();
      var artworkOk = validateSimpleArtwork();
      return jobOk && artworkOk;
    }
    if (simpleJobName) simpleJobName.addEventListener('input', validateSimpleJobName);
    if (simpleArtworkInput) simpleArtworkInput.addEventListener('change', validateSimpleArtwork);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn && addBtn.disabled) return;
      if (!validateRequiredFields()) {
        var firstInvalid = form.querySelector('.field-invalid');
        if (firstInvalid) { firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' }); firstInvalid.focus(); }
        return;
      }
      var formData = new FormData(form);
      if (addBtn) { addBtn.disabled = true; addBtn.dataset.prevLabel = addBtn.textContent; addBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) { return res.json().then(function (err) { throw err; }); }
          return res.json();
        })
        .then(function () {
          if (window.BannerllyCart) { window.BannerllyCart.refresh(true); }
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.dataset.prevLabel || 'Add to Cart'; }
        })
        .catch(function (err) {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.dataset.prevLabel || 'Add to Cart'; }
          var msg = (err && err.description) ? err.description : 'Sorry — could not add this to the cart. Please try again.';
          alert(msg);
        });
    });
  }

  /* ---------- shipping rate estimator (real Shopify cart shipping rates) ---------- */
  function initShippingEstimate(root) {
    var wrap = (root || document).querySelector('#shippingEstimate');
    if (!wrap || wrap.dataset.shipInit) return;
    wrap.dataset.shipInit = '1';

    var toggle = wrap.querySelector('#shippingEstimateToggle');
    var body = wrap.querySelector('#shippingEstimateBody');
    var countryEl = wrap.querySelector('#shipEstCountry');
    var stateEl = wrap.querySelector('#shipEstState');
    var zipEl = wrap.querySelector('#shipEstZip');
    var submitBtn = wrap.querySelector('#shipEstSubmit');
    var results = wrap.querySelector('#shipEstResults');

    if (toggle && body) {
      toggle.addEventListener('click', function () {
        body.hidden = !body.hidden;
        toggle.classList.toggle('open', !body.hidden);
      });
    }

    function money(cents) {
      return '$' + (parseFloat(cents) / 100).toFixed(2);
    }

    function paramsFor(country, province, zip) {
      var p = new URLSearchParams();
      p.set('shipping_address[zip]', zip);
      p.set('shipping_address[country]', country);
      if (province) p.set('shipping_address[province]', province);
      return p.toString();
    }

    function pollRates(qs, attemptsLeft) {
      fetch('/cart/async_shipping_rates.json?' + qs, { headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          if (res.status === 204) throw { retry: true }; // not ready yet
          if (!res.ok) throw { retry: false };
          return res.json();
        })
        .then(function (data) {
          renderRates(data && data.shipping_rates);
        })
        .catch(function (err) {
          if (err && err.retry && attemptsLeft > 0) {
            setTimeout(function () { pollRates(qs, attemptsLeft - 1); }, 900);
          } else {
            renderRates(null);
          }
        });
    }

    function renderRates(rates) {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Get rates'; }
      if (!results) return;
      if (!rates || !rates.length) {
        results.innerHTML = '<p class="shipping-estimate-empty">No rates found for that address. Double-check the ZIP/state, or your exact rate will still be shown at checkout.</p>';
        return;
      }
      var html = '<div class="shipping-estimate-list">';
      rates.forEach(function (r) {
        html += '<div class="shipping-estimate-item"><span>' + r.name + '</span><span>' + money(r.price) + '</span></div>';
      });
      html += '</div>';
      results.innerHTML = html;
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var country = countryEl ? countryEl.value : 'United States';
        var province = stateEl ? stateEl.value.trim() : '';
        var zip = zipEl ? zipEl.value.trim() : '';
        if (!zip) {
          if (results) results.innerHTML = '<p class="shipping-estimate-empty">Enter a ZIP/postal code to get rates.</p>';
          return;
        }
        submitBtn.disabled = true;
        submitBtn.textContent = 'Getting rates…';
        if (results) results.innerHTML = '';

        var qs = paramsFor(country, province, zip);
        fetch('/cart/prepare_shipping_rates.json?' + qs, { method: 'POST', headers: { 'Accept': 'application/json' } })
          .then(function () {
            pollRates(qs, 6); // up to ~6 tries, ~5s total
          })
          .catch(function () { renderRates(null); });
      });
    }
  }

  /* ---------- boot + Theme Editor events ---------- */
  /* ---------- category showcase (hover/click to swap right-side panel) ---------- */
  function initCategoryShowcase(root) {
    var showcase = (root || document).querySelector('.cs-showcase');
    if (!showcase || showcase.dataset.csInit) return;
    showcase.dataset.csInit = '1';

    var items = Array.prototype.slice.call(showcase.querySelectorAll('.cs-item'));
    var panels = Array.prototype.slice.call(showcase.querySelectorAll('.cs-panel'));

    function activate(targetId) {
      items.forEach(function (i) {
        var isActive = i.dataset.panel === targetId;
        i.classList.toggle('active', isActive);
        i.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (p) { p.classList.toggle('active', p.id === targetId); });
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { activate(item.dataset.panel); });
      item.addEventListener('click', function (e) {
        e.preventDefault();
        activate(item.dataset.panel);
      });
      item.addEventListener('focus', function () { activate(item.dataset.panel); });
    });
  }

  /* ---------- category page: spotlight single product via #product-N hash ---------- */
  function initProductSpotlight() {
    var hash = window.location.hash; // e.g. "#product-2"
    if (!hash || !/^#product-\d+$/.test(hash)) return;

    var target = document.querySelector(hash);
    if (!target || !target.classList.contains('category-product-card')) return;

    var grid = target.closest('.category-product-grid');
    if (!grid) return;

    // hide every other card
    var allCards = grid.querySelectorAll('.category-product-card');
    allCards.forEach(function (card) {
      if (card !== target) card.style.display = 'none';
    });

    // inject "Show all" bar above the grid if not already there
    if (!grid.parentNode.querySelector('.spotlight-bar')) {
      var title = target.querySelector('.cpc-title');
      var label = title ? title.textContent.trim() : 'this product';
      var bar = document.createElement('div');
      bar.className = 'spotlight-bar';
      bar.innerHTML =
        '<span>Showing: <strong>' + label + '</strong></span>' +
        '<button type="button" class="spotlight-reset">Show all &rarr;</button>';
      grid.parentNode.insertBefore(bar, grid);

      bar.querySelector('.spotlight-reset').addEventListener('click', function () {
        allCards.forEach(function (card) { card.style.display = ''; });
        bar.remove();
        // clear hash without reloading
        history.replaceState(null, '', window.location.pathname + window.location.search);
      });
    }

    // scroll the card into view smoothly
    setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 120);
  }

  function initAll(root) {
    bindScroll();
    observeReveals(root);
    initCycleWords(root);
    initHeroSlider(root);
    initCalculator(root);
    initSimpleProduct(root);
    initShippingEstimate(root);
    initCategoryShowcase(root);
    initProductSpotlight();
    initCartPage(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { observeReveals(e.target); });
})();